module.exports = __webpack_public_path__ + "img/e.5a5595ef.svg";